/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { Button, Grid, Link, Paper, Tab, Tabs, Typography } from '@material-ui/core/';
import { useGlobal } from '@rcg/ui-react';
import { useMutation } from '@apollo/client';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import Clear from '@material-ui/icons/Clear';
import { Carousel } from '../../components';
import useStyles from './index.style';
import GuestFields from './GuestFields';
import { UPDATE_GUESTINFO } from '../../graphql/mutations';
import IconAdult from '../../components/Icons/Adult';
import { INVALID_NAMES, ERROR_CODE_LOCKED_BOOKING } from '../../commons';
import Loader from '../../components/Loader';
import {
  REPRICE_WARNING,
  REPRICE_ERROR,
  SESSION_STORAGE_CURRENT_BOOKING,
  REPRICE_CRCR_ERROR,
} from '../../commons/constants';
import {
  getSessionStorageItem,
  checkFieldUpdated,
  checkFieldsUpdated,
  getGuestInfoFlags,
  disableEditGuestInformation,
} from '../../commons/utils';
import { trackGuestInfoInteraction } from '../../commons/tracking/editGuestInfoTracking';

export const Fields = (props) => {
  const {
    guests,
    handleChange,
    isValid,
    reservation,
    setFieldTouched,
    setFieldValue,
    setNotification,
    values: { guests: guestsValues },
    country: { phoneNumber },
    setSuccesUpdate,
    ldFlags,
    guestTab,
  } = props;

  const classes = useStyles();
  const { renderContent } = useGlobal();
  const [selectedTab, updateTab] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const [validCasResponse, setValidCasResponse] = useState(true);
  const [openRepriceModal, setOpenRepriceModal] = useState(false);
  const refMenuPreferences = React.createRef();
  const refIntroPreferences = React.createRef();
  const refFormPreferences = React.createRef();
  const isAFlightbooked = guests.some((guest) => guest.airAccommodations !== null);
  const [isFieldUpdated, setFieldUpdated] = useState(false);
  const [updatedFields, setUpdatedFields] = useState([]);

  const currentBookingInfo = getSessionStorageItem(SESSION_STORAGE_CURRENT_BOOKING);

  const { bookingType, showEditGuestInformationCta, showViewGuestInformationCta } =
    getGuestInfoFlags(currentBookingInfo, ldFlags);
  const status = currentBookingInfo?.status || 'BOOKED';

  const disableField = disableEditGuestInformation(
    bookingType,
    showEditGuestInformationCta,
    showViewGuestInformationCta,
    isAFlightbooked,
    status,
  );

  const carouselIntroConfig = {
    arrows: false,
    centerMode: false,
    draggable: false,
    focusOnSelect: true,
    infinite: false,
    slidesToShow: 1,
    fade: true,
    beforeChange: (current, next) => {
      refMenuPreferences.current.slickGoTo(next);
      refFormPreferences.current.slickGoTo(next);
    },
    responsive: [],
  };
  const carouselFormsConfig = {
    arrows: false,
    centerMode: true,
    draggable: false,
    focusOnSelect: false,
    infinite: false,
    slidesToShow: 1,
    variableWidth: false,
    centerPadding: '0',
    fade: true,
    beforeChange: (current, next) => {
      refMenuPreferences.current.slickGoTo(next);
      refIntroPreferences.current.slickGoTo(next);
    },
    responsive: [],
  };

  const change = (name, e) => {
    const fieldName = name.split('.').pop();
    const index = name.split('.')[1];
    const { value } = e.target;
    const updatedFieldsState = { updatedFields, setUpdatedFields };
    checkFieldUpdated(
      currentBookingInfo,
      fieldName,
      value,
      index,
      setFieldUpdated,
      updatedFieldsState,
    );

    e.persist();
    handleChange(e);
    setFieldTouched(name, true, false);
  };

  const guestTabsLabels = [
    renderContent('formBookingAmendGuestTabsLabelPrimary', 'Primary Passenger'),
    renderContent('formBookingAmendGuestTabsLabelSecond', 'Passenger 2'),
    renderContent('formBookingAmendGuestTabsLabelThird', 'Passenger 3'),
    renderContent('formBookingAmendGuestTabsLabelFourth', 'Passenger 4'),
  ];

  const a11yProps = (index) => {
    return {
      id: `guest-tab-${index}`,
      'aria-controls': `guest-tabpanel-${index}`,
    };
  };

  const isTabDisable = (currentIndex) =>
    !!(
      !disableField &&
      !currentIndex &&
      props.errors.guests !== undefined &&
      props.errors.guests[currentIndex] !== undefined
    );

  const isSubmitDisable = () => {
    return !isValid || !validCasResponse || !isFieldUpdated;
  };

  const isInvalidName = (guest) => {
    return INVALID_NAMES.includes(guest.firstName) || INVALID_NAMES.includes(guest.lastName);
  };

  const guestTabs = guests.map((_e, i) => {
    const uniqueKey = `guestTab-${i}`;
    return (
      <Tab
        className={
          props.errors?.guests?.[i] || isInvalidName(props.values?.guests?.[i])
            ? 'hasErrors'
            : 'noErrors'
        }
        tabIndex="-1"
        icon={<IconAdult />}
        key={uniqueKey}
        {...a11yProps(i)}
        label={<span className="tabText">{guestTabsLabels[i]}</span>}
        disabled={isTabDisable(i)}
        disableRipple
      />
    );
  });

  const handleTabs = (event, newValue) => {
    updateTab(newValue);
  };

  const handleOpenRepriceModal = () => {
    setOpenRepriceModal(true);
  };

  const handleCloseRepriceModal = () => {
    setOpenRepriceModal(false);
  };

  const [updateGuestInfo] = useMutation(UPDATE_GUESTINFO, {
    onCompleted: () => {
      setFieldUpdated(false);
      setNotification({
        title: renderContent('formBookingAmendGuestSubmitSuccessTitle', 'SUCCESS!'),
        description: renderContent(
          'formBookingAmendGuestSubmitSuccess',
          'Your guest information was saved successfully',
        ),
        type: 'success',
        open: true,
      });
      setSuccesUpdate(true);
      trackGuestInfoInteraction('success');
    },
    onError: (result) => {
      setSuccesUpdate(false);
      const error = result.graphQLErrors.find(({ extensions }) => !!extensions.code);
      const errStatusCode = error?.extensions?.code;
      const showModalReprice = errStatusCode === REPRICE_WARNING;
      const showRepriceErrorBanner = errStatusCode === REPRICE_ERROR;
      const showTravelProtectionWarning = errStatusCode === REPRICE_CRCR_ERROR;
      const renderContentKey = `formBookingAmendGuestSubmitError${
        errStatusCode === ERROR_CODE_LOCKED_BOOKING ? 'BookingLocked' : 'Default'
      }`;
      const renderContentTitle = `formBookingAmendGuestSubmitErrorTitle${
        errStatusCode === ERROR_CODE_LOCKED_BOOKING ? 'BookingLocked' : 'Default'
      }`;
      if (showTravelProtectionWarning) {
        setNotification({
          title: renderContent(
            'formBookingAmendGuestSubmitTravelProtectionErrorTitle',
            'IMPORTANT',
          ),
          description: renderContent(
            'formBookingAmendGuestSubmitTravelProtectionErrorDescription',
            'Due to the recent changes, the Royal Caribbean Travel Protection Insurance has been removed from the booking. ',
          ),
          open: true,
          type: 'warning',
        });
      } else if (showRepriceErrorBanner) {
        trackGuestInfoInteraction('repriced');
        setNotification({
          title: renderContent(
            'formBookingAmendGuestSubmitRepriceErrorTitle',
            'PLEASE GIVE US A CALL',
          ),
          description: renderContent(
            'formBookingAmendGuestSubmitRepriceErrorDescription',
            'This changed updated the balance of your booking. Please call us at ',
          ),
          open: true,
          linkLabel: phoneNumber,
          type: 'error',
          useSlot: true,
        });
      } else if (!showModalReprice) {
        trackGuestInfoInteraction('error');
        setNotification({
          title: renderContent(renderContentTitle, 'OOPS! SOMETHING WENT WRONG'),
          description: renderContent(
            renderContentKey,
            'Unfortunately your information could not be updated at this time. Please try again later.',
          ),
          open: true,
          type: 'error',
        });
      } else {
        trackGuestInfoInteraction('assitance');
        handleOpenRepriceModal();
      }
    },
  });

  const submit = async (event) => {
    event.preventDefault();
    setShowLoader(true);
    const removeKeys = ['airAccommodations', 'age', '_mutableFields', '__typename'];
    const guestSubmission = guestsValues.map((guest) => {
      const validKeys = {};
      Object.keys(guest).forEach((key) => {
        if (!removeKeys.includes(key)) {
          validKeys[key] = guest[key];
        }
        if (key === 'nationality') {
          if (validKeys[key] !== 'BR') {
            // eslint-disable-next-line no-param-reassign
            guest.travelDocument = '';
          }
        }
      });

      return validKeys;
    });

    checkFieldsUpdated(guestSubmission, currentBookingInfo.guests);

    await updateGuestInfo({
      variables: {
        guestInput: guestSubmission,
      },
    });
    setShowLoader(false);
  };

  useEffect(() => {
    updateTab(guestTab || 0);
  }, []);

  return (
    <form onSubmit={submit.bind(this)} className="roomPreferences">
      {/* INTRO TEXT */}
      <Carousel className="introPreferences" ref={refIntroPreferences} {...carouselIntroConfig}>
        <div>
          <Typography className="introPreferences__title" component="h3" variant="inherit">
            {renderContent('preferencesMenuBookingHowIsTraveling', "Who's Traveling?")}
          </Typography>
          {!disableField && (
            <Typography className="introPreferences__subTitle" component="h4" variant="inherit">
              {renderContent(
                'preferencesMenuBookingAmendGuestInfo',
                "Let's complete your travel party information. Remember first and last names must match what appears on government-issued photo IDs",
              )}
            </Typography>
          )}
        </div>
      </Carousel>
      {/* FORMS  */}
      <Paper className="formPreferences">
        <Carousel {...carouselFormsConfig} ref={refFormPreferences}>
          <div className="guestInfo">
            <div className="formTitle">
              {renderContent('formBookingAmendTitleLabelGuestInfo', 'Guest info')}
            </div>
            <Tabs
              className="guestTabs"
              value={selectedTab}
              onChange={handleTabs}
              aria-label="Guest Tabs"
              TabIndicatorProps={{ style: { backgroundColor: 'white' } }}>
              {guestTabs}
            </Tabs>
            <GuestFields
              {...props}
              change={change}
              guests={guests}
              reservation={reservation}
              selectedTab={selectedTab}
              setFieldValue={setFieldValue}
              setValidCasResponse={setValidCasResponse}
              currentBookingInfo={currentBookingInfo}
              setFieldUpdated={setFieldUpdated}
              updatedFieldsState={{ updatedFields, setUpdatedFields }}
            />
          </div>
        </Carousel>
        {!disableField && (
          <Grid xs={12} item classes={{ root: 'actions' }}>
            <Button
              data-testid="login-submit"
              className={classes.buttons}
              color="primary"
              disabled={isSubmitDisable()}
              type="submit"
              variant="contained">
              {renderContent('formBookingAmendSaveContinue', 'SAVE & CONTINUE')}
            </Button>
          </Grid>
        )}
      </Paper>
      <Loader display={showLoader} />
      {openRepriceModal && (
        <Modal
          data-testid="reprice-modal"
          aria-labelledby="reprice-modal-title"
          aria-describedby="reprice-modal-description"
          className={classes.modal}
          open={openRepriceModal}
          closeAfterTransition>
          <Fade in={openRepriceModal}>
            <div className={classes.paper}>
              <Link
                component="button"
                className={classes.closeButton}
                onClick={handleCloseRepriceModal}
                data-testid="reprice-modal-close">
                <Clear className={classes.closeIcon} />
              </Link>
              <Typography variant="h5" align="center" className={classes.modalTitle}>
                {renderContent(`preferencesModalTitle`, `Can't update booking`)}
              </Typography>
              <Typography className={classes.modalContent}>
                {renderContent(
                  'preferencesModaContent',
                  'Making this change looks like it will update your balance on your booking. ',
                )}
              </Typography>
              <Typography
                className={classes.modalContent}
                dangerouslySetInnerHTML={{
                  __html: renderContent(
                    'preferencesModalAssistanceMessage',
                    'Please call us at {phone_number} for assistance. ',
                    {
                      findReplace: [
                        {
                          find: '{phone_number}',
                          replace: `<a class="message__description__link" href="tel:${phoneNumber}">${phoneNumber}</a>`,
                        },
                      ],
                    },
                  ),
                }}
              />
            </div>
          </Fade>
        </Modal>
      )}
    </form>
  );
};

export default Fields;
